<template>
    <div class="body-wrapper home">
        <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
            <landing-nav-bar @scrollToTarget="scrollToElement"/>
            <div>
                <div class="content-wrapper px-5">
                    <div class="main-section-content mt-5 d-flex flex-column pb-4">
                        <h1 class="text-title">Contractor Pre-qualification, Compliance Management, Strata
                            Quotes and Work Order Management</h1>
                        <div>Onboard & Pre-qualify your suppliers, contractors & workers. Manage their
                            compliance by using our software.
                        </div>
                        <div class="mt-4">
                            <b-button variant="outline-primary">
                                Learn More
                            </b-button>
                        </div>
                        <div class="login-img flex-grow-1 mt-4">
                            <b-img src="./images/home/building1.jpg" class="h-100 w-100" style="max-height: 550px;" fluid alt="Responsive image"></b-img>
                        </div>
                    </div>
                    <DemoComponent/>
                </div>
                <div class="py-2 my-2 px-4 carousel-icons">
                    <div class="px-4 position-relative">
                        <carousel class="px-3" :perPage="5" :mouse-drag="true" ref="carousel"
                                  :paginationEnabled="false"
                                  :loop="false" :scrollPerPage="false">
                            <slide v-for="(image, index) in logos" :key="index">
                                <img :style="`height: ${image.height}px; width: ${image.width}px;`"
                                     :src="image.src" alt="Image">
                            </slide>
                        </carousel>
                        <div @click="nextSlide" class="arrow right" :class="{ 'disabled': disableNext }">
                            <i class="fas fa-arrow-right"></i>
                        </div>
                        <div @click="prevSlide" class="arrow left" :class="{ 'disabled': disablePrev }">
                            <i class="fas fa-arrow-left"></i>
                        </div>
                    </div>
                </div>
                <div ref="platformElement" class="mb-4"></div>
                <div class="content-wrapper px-5">
                    <div class="mt-2r">
                        <div class="text-center">
                            <h1 class="text-header">One platform to manage your obligations</h1>
                            <div class="text-caption text-center mr-auto ml-auto" style="max-width: 800px;">
                                The StrataConnex platform is used by leading organisations in
                                Australia and New Zealand to manage their contractor compliance and ESG
                                responsibilities.
                            </div>
                        </div>
                        <div class="mt-3r">
                            <b-row>
                                <b-col v-for="platform in platforms" :key="platform.title" md="6" lg="3">
                                    <app-card :title="platform.title"
                                              :image="platform.image"
                                              :body="platform.description">
                                    </app-card>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
                <div class="text-center mt-3 px-5" ref="resourcesElement">
                    <b-img src="./images/home/resources.png" fluid alt="Responsive image"></b-img>
                </div>
                <div class="contact mt-5 px-5" ref="contactElement">
                    <app-card>
                        <template #header>
                            <h1 class="text-header pb-0">Contact Us</h1>
                            <div class="text-caption pt-0 mb-5">We can help. Our team of experts is on hand to answer
                                your questions.
                            </div>
                        </template>
                        <b-container>
                            <b-row align-h="between">
                                <b-col>
                                    <p class="h2 mb-3">
                                        <b-icon icon="telephone-fill" animation="cylon" variant="primary"></b-icon>
                                    </p>
                                    <div class="text-caption text-center" style="max-width: 800px;">
                                        +(1)23465754556
                                    </div>
                                </b-col>

                                <b-col>
                                    <div style="width: 1px; height: 72px; background-color: gray;" class="m-auto"></div>
                                </b-col>
                                <b-col>
                                    <p class="h2 mb-3">
                                        <b-icon icon="envelope-fill" animation="cylon" variant="primary"></b-icon>
                                    </p>
                                    <div class="text-caption text-center" style="max-width: 800px;">
                                        support@strataconnex.com.au
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </app-card>
                </div>
                <div class="mt-5 px-5">
                    <footer-component></footer-component>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {Form, HasError} from "vform";
import FooterComponent from "./includes/FooterComponent.vue";
import DemoComponent from "./DemoComponent.vue";
import LandingNavBar from "./includes/LandingNavBar.vue";
import AppCard from "../../pages/common/card/AppCard.vue";
import {Carousel, Slide} from 'vue-carousel';


// import FooterComponent from "../../../pages/includes/FooterComponent.vue";
// import RegisterText from "@frontendPages/Authentication/RegisterText.vue";

Vue.component(HasError.name, HasError);

export default {
    components: {
        FooterComponent,
        LandingNavBar,
        AppCard,
        DemoComponent,
        Carousel,
        Slide
        //     // RegisterText,
    },
    data() {
        return {
            settings: {
                "dots": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 4,
                "slidesToScroll": 1
            },
            logos: [
                {src: './images/home/logos/BCS-Logo.png', height: 90, width: 'auto'},
                {src: './images/home/logos/Clisdells-Logo.png', height: 70, width: 'auto'},
                {src: './images/home/logos/Depenable-Logo.jpeg', height: 70, width: 'auto'},
                {src: './images/home/logos/GK-Strata-Logo.png', height: 110, width: 'auto'},
                {src: './images/home/logos/WestSide-Strata-Logo.jpeg', height: 60, width: 'auto'},
                {src: './images/home/logos/Clisdells-Logo.png', height: 70, width: 'auto'},
                {src: './images/home/logos/Depenable-Logo.jpeg', height: 70, width: 'auto'},
                {src: './images/home/logos/GK-Strata-Logo.png', height: 100, width: 'auto'},
                {src: './images/home/logos/WestSide-Strata-Logo.jpeg', height: 60, width: 'auto'},
            ],
            platforms: [
                {
                    image: './images/home/platform/platform-1.png',
                    title: 'Contractor Compliance',
                    description: `We provide Strata Companies with reassurance that their Prime contractors are adhering to legal and regulatory requirements to work for them, reducing the risk involved. Our services help contractors establish and uphold compliance with strata standards.`
                },
                {
                    image: './images/home/platform/platform-2.png',
                    title: 'Industry Specific Solutions',
                    description: `Strata Conex is a cloud-based compliance & work order management tool for your strata companies. We empower strata managers to easily collect, track and manage third-party contractor compliance and get quote & assign word order.`
                },
                {
                    image: './images/home/platform/platform-3.png',
                    title: 'Contractor Approved',
                    description: `Contractor Compliance was founded because there had to be a better way for contractors to submit compliance requirements. We have simplified the document upload process so that anyone can use it. We also simplified the pricing model so it's available to the masses.`
                },
                {
                    image: './images/home/platform/platform-4.png',
                    title: 'Reduce Cost & Reduce Risk',
                    description: 'We understand the importance of your time. The Strata Connex manages the entire process of OHS/WHS contractor prequalification, saving your internal resources and enabling you to dedicate more time to your core business activities.'
                }
            ],
            disableNext: false,
            disablePrev: true,
        };
    },
    methods: {
        scrollToElement(ref) {
            const target = this.$refs[ref];
            target.scrollIntoView({behavior: 'smooth'});
            // window.scrollBy(0, 50);
        },
        nextSlide() {
            this.disableNext = false;
            this.disablePrev = false;
            const nextPage = this.$refs.carousel.getNextPage();
            const currentPage = this.$refs.carousel.currentPage;
            if (nextPage === currentPage) {
                this.disableNext = true;
            }
            this.$refs.carousel.goToPage(nextPage);
        },
        prevSlide() {
            this.disableNext = false;
            this.disablePrev = false;
            const prevPage = this.$refs.carousel.getPreviousPage();
            const currentPage = this.$refs.carousel.currentPage;
            if (prevPage === currentPage) {
                this.disablePrev = true;
            }
            this.$refs.carousel.goToPage(prevPage);
        }
    },
    mounted() {
    },
}
</script>


